var map = {
	"./amazon.svg": 818,
	"./archive_org.svg": 819,
	"./arrow-left.svg": 820,
	"./arrow-right.svg": 821,
	"./bell.svg": 822,
	"./book.svg": 823,
	"./bookshelf.svg": 824,
	"./caret-down.svg": 825,
	"./caret.svg": 826,
	"./chefshat.svg": 827,
	"./circletick-outline.svg": 828,
	"./circletick-solid.svg": 829,
	"./closed-padlock.svg": 830,
	"./cog.svg": 831,
	"./collections-outline.svg": 832,
	"./collections-solid.svg": 833,
	"./dots.svg": 834,
	"./envelope.svg": 835,
	"./error-outline.svg": 836,
	"./facebook-grey.svg": 837,
	"./facebook.svg": 838,
	"./favourite.svg": 839,
	"./feature-outline.svg": 840,
	"./feature-solid.svg": 841,
	"./filter.svg": 842,
	"./gift.svg": 843,
	"./grid.svg": 844,
	"./help.svg": 845,
	"./home-outline.svg": 846,
	"./home.svg": 847,
	"./info-outline.svg": 848,
	"./instagram-grey.svg": 849,
	"./instagram.svg": 850,
	"./list-add.svg": 851,
	"./list.svg": 852,
	"./magnifier.svg": 853,
	"./native-share.svg": 854,
	"./opened-padlock.svg": 855,
	"./pinterest.svg": 856,
	"./plus.svg": 857,
	"./printer.svg": 858,
	"./push-pin-filled.svg": 859,
	"./push-pin.svg": 860,
	"./restaurant.svg": 861,
	"./search.svg": 862,
	"./tick.svg": 863,
	"./twitter-grey.svg": 864,
	"./twitter.svg": 865,
	"./voice.svg": 866,
	"./x-big.svg": 867,
	"./x.svg": 868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 817;